import React from "react";
import { Table, Badge } from "reactstrap";
import { Link } from "react-router-dom";
import { formatDate } from "../../../../utils/date";
import { TRIAL_ATTENDANCE_STATUS } from "../../../../constants/enrollments";
import { TRIAL_ATTENDANCE_STATUS_LABELS } from "../../../../constants/enrollments";
import { resolveTrialAttendance } from "../helpers";

const TrialsTable = ({ trials, loading }) => {

    const getStatusBadge = (enrollment) => {
        const resolved = resolveTrialAttendance(enrollment);
        switch (resolved) {
            case TRIAL_ATTENDANCE_STATUS.PRESENT:
                return <Badge color="success" className="rounded-0">{TRIAL_ATTENDANCE_STATUS_LABELS[TRIAL_ATTENDANCE_STATUS.PRESENT]}</Badge>;
            case TRIAL_ATTENDANCE_STATUS.ABSENT:
                return <Badge color="danger" className="rounded-0">{TRIAL_ATTENDANCE_STATUS_LABELS[TRIAL_ATTENDANCE_STATUS.ABSENT]}</Badge>;
            case TRIAL_ATTENDANCE_STATUS.PENDING:
            default:
                return <Badge color="info" className="rounded-0">{TRIAL_ATTENDANCE_STATUS_LABELS[TRIAL_ATTENDANCE_STATUS.PENDING]}</Badge>;
        }
    };

    const getConversionBadge = (enrollment) => {
        const resolved = resolveTrialAttendance(enrollment);
        if (enrollment.convertedToSale) {
            return <Badge color="success" className="rounded-0"><i className="bx bx-check-circle me-1"></i>Convertido</Badge>;
        }
        if (resolved === TRIAL_ATTENDANCE_STATUS.PRESENT) {
            return <Badge color="warning" className="rounded-0"><i className="bx bx-time me-1"></i>Em Andamento</Badge>;
        }
        if (resolved === TRIAL_ATTENDANCE_STATUS.ABSENT) {
            return <Badge color="dark" className="rounded-0"><i className="bx bx-x-circle me-1"></i>Perdido (Falta)</Badge>;
        }
        return <Badge color="secondary" className="rounded-0">Aguardando</Badge>;
    };

    if (loading) {
        return <div className="text-center p-4">Carregando aulas experimentais...</div>;
    }

    if (!trials || trials.length === 0) {
        return (
            <div className="text-center text-muted p-5 border-top">
                <i className="bx bx-ghost display-4"></i>
                <p className="mt-3 font-size-14">Nenhuma aula experimental encontrada neste período.</p>
            </div>
        );
    }

    return (
        <div className="table-responsive">
            <Table className="align-middle mb-0" hover>
                <thead className="table-light">
                    <tr>
                        <th>Aluno / Lead</th>
                        <th>Data e Hora</th>
                        <th>Atividade</th>
                        <th>Professor</th>
                        <th>Consultor(a)</th>
                        <th>Presença</th>
                        <th>Conversão</th>
                    </tr>
                </thead>
                <tbody>
                    {trials.map((trial) => (
                        <tr key={trial.id}>
                            <td>
                                <div className="d-flex align-items-center">
                                    <div>
                                        <h5 className="font-size-14 mb-1">
                                            <Link to={`/members/${trial.idMember}`} className="text-dark">
                                                {trial.memberName || 'Aluno Desconhecido'}
                                            </Link>
                                        </h5>
                                        {trial.memberPhone && (
                                            <small className="text-muted">{trial.memberPhone}</small>
                                        )}
                                    </div>
                                </div>
                            </td>
                            <td>
                                {formatDate(trial.sessionDate)} <br />
                                <small className="text-muted">{trial.startTime || '—'}</small>
                            </td>
                            <td>
                                {trial.activityName || 'N/A'}
                            </td>
                            <td>{trial.employeeName || 'Não Informado'}</td>
                            <td>{trial.consultantName || 'Não Atribuído'}</td>
                            <td>{getStatusBadge(trial)}</td>
                            <td>{getConversionBadge(trial)}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default TrialsTable;
